import {Controller} from "stimulus"

export default class extends Controller {

  connect() {
    super.connect();

    this.initializeCallCount();
    let callCount = parseInt(localStorage.getItem('callCount')) || 0;
    if(callCount < 3 && this.element.dataset.verifyDomain === 'true') {
      localStorage.setItem('callCount', ++callCount);
      this.verifyDomainNotification();
    }
    this.closeSwal();
  }

  copyToClipboard(event) {
    const button = event.currentTarget;
    const container = button.closest("[data-controller='verify-domain']");
    const input = container.querySelector("input[data-verify-domain-target='copy']");

    input.style.display = "block";
    input.select();
    document.execCommand("copy");
    input.style.display = "none";

    if (this.hasCopyModalTarget) {
      jQuery(this.copyModalTarget).modal("toggle");
    }

    toastr.success("Copied to clipboard");
  }

  initializeCallCount() {
    const today = new Date().toDateString();
    const lastCallDate = localStorage.getItem('lastCallDate');

    if (lastCallDate !== today) {
      localStorage.setItem('lastCallDate', today);
      localStorage.setItem('callCount', 0);
    }
  }

  async verifyDomainNotification(){
    let controller = this;

    let title = 'Configure DKIM for your domain!';
    let text  = 'To improve email deliver ability and to avoid spam, please update the DKIM record to your domain.';

    try {
      const data = await this.getTranslatedWords(title, text);

      if (data.length === 2) {
        [title, text] = data;
      }

      swal({
        title: title,
        text: text,
        type: 'info',
        confirmButtonClass: 'btn btn-lg btn-primary waves-effect waves-light m-l-10'
      }).then(function () {

      }, function (dismiss) {
      })
    } catch (e) {}
  }

  async getTranslatedWords(title, text) {
    return await Weglot.translate({
      words: [
        {t: 1, w: title},
        {t: 1, w: text}
      ],
      languageTo: Weglot.getCurrentLang(),
    });
  }

  closeSwal() {
    setTimeout(() => {
      swal.close();
    }, 5000);
  }
}
